import { AuthService } from "./../providers/auth-service";
import { BrowserModule } from "@angular/platform-browser";
import { ErrorHandler, NgModule } from "@angular/core";
import { IonicApp, IonicErrorHandler, IonicModule } from "ionic-angular";
import { SplashScreen } from "@ionic-native/splash-screen";
import { StatusBar } from "@ionic-native/status-bar";
import { Geolocation } from "@ionic-native/geolocation";
import { HttpModule } from "@angular/http";
import { AutoCompleteModule } from "ionic2-auto-complete";
import { Ng2OrderModule } from "ng2-order-pipe";
import { Facebook } from "@ionic-native/facebook";
import { GooglePlus } from "@ionic-native/google-plus";
import { SocialSharing } from "@ionic-native/social-sharing";

import { MyApp } from "./app.component";
import { HomePage } from "../pages/home/home";
import { EntrarPage } from "../pages/entrar/entrar";
import { CadastroPage } from "../pages/cadastro/cadastro";
import { LoginPage } from "../pages/login/login";
import { CarregandoPage } from "../pages/carregando/carregando";
import { VerMapaPage } from "../pages/vermapa/vermapa";
import { SobrePage } from "../pages/sobre/sobre";
import { TermosPage } from "../pages/termos/termos";
import { SobreNosPage } from "../pages/sobrenos/sobrenos";
import { AjudaPage } from "../pages/ajuda/ajuda";
import { PoliticaPage } from "../pages/politica/politica";
import { OcorrenciasPage } from "../pages/ocorrencias/ocorrencias";
import { AddOcorrenciaPage } from "../pages/ocorrencias/addocorrencia";
import { AddDependentePage } from "../pages/dependentes/adddependente";
import { EscolherDependentePage } from "../pages/dependentes/escolherdependente";
import { EscolherSintomaPage } from "../pages/sintomas/escolhersintoma";
import { AddDadosPage } from "../pages/dados/adddados";
import { ModalOcorrencias } from "../pages/ocorrencias/modal";
import { ModalDoencas } from "../pages/vermapa/modal";

@NgModule({
  declarations: [
    MyApp,
    HomePage,
    EntrarPage,
    CadastroPage,
    LoginPage,
    CarregandoPage,
    VerMapaPage,
    SobrePage,
    TermosPage,
    SobreNosPage,
    AjudaPage,
    PoliticaPage,
    OcorrenciasPage,
    AddOcorrenciaPage,
    AddDependentePage,
    EscolherDependentePage,
    EscolherSintomaPage,
    AddDadosPage,
    ModalOcorrencias,
    ModalDoencas
  ],
  imports: [
    BrowserModule,
    HttpModule,
    AutoCompleteModule,
    Ng2OrderModule,
    IonicModule.forRoot(MyApp, {
      backButtonText: ""
    })
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    HomePage,
    EntrarPage,
    CadastroPage,
    LoginPage,
    CarregandoPage,
    VerMapaPage,
    SobrePage,
    TermosPage,
    SobreNosPage,
    AjudaPage,
    PoliticaPage,
    OcorrenciasPage,
    AddOcorrenciaPage,
    AddDependentePage,
    EscolherDependentePage,
    EscolherSintomaPage,
    AddDadosPage,
    ModalOcorrencias,
    ModalDoencas
  ],
  providers: [
    StatusBar,
    SplashScreen,
    Geolocation,
    AuthService,
    Facebook,
    GooglePlus,
    SocialSharing,
    { provide: ErrorHandler, useClass: IonicErrorHandler }
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts